import { render } from "./DataFormatView.vue?vue&type=template&id=3b9d8936&scoped=true"
import script from "./DataFormatView.vue?vue&type=script&lang=js"
export * from "./DataFormatView.vue?vue&type=script&lang=js"

import "./DataFormatView.vue?vue&type=style&index=0&id=3b9d8936&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b9d8936"]])

export default __exports__